import type React from 'react';
import { JACKPOT_NAMES, SECTION_NAMES } from '@repo/common';
import type IGameSettings from '../../../../../types/models/IGameSettings';

interface SectionBadgeConfig {
  fileName?: string;
  plateWidth?: string;
  spjLeft?: string;
  spjTop?: string;
  spjWidth?: string;
  spjWidthMd?: string;
  normalPictureWidth?: string;
  normalImgWidth?: string;
}

const DEFAULT_BADGE_CONFIG: SectionBadgeConfig = {
  plateWidth: '40%',
  spjLeft: '20%',
  spjWidth: '36%',
  spjWidthMd: '40%',
  normalPictureWidth: '50%',
  normalImgWidth: '80%',
};

export const SECTION_BADGE_REGISTRY: Partial<Record<string, SectionBadgeConfig>> = {
  [SECTION_NAMES.PREMIUM_LINK]: {
    fileName: 'premium_link',
    plateWidth: '62.8%',
    spjLeft: '31.4%',
    spjTop: '0',
    spjWidth: '62.8%',
    spjWidthMd: '62.8%',
    normalPictureWidth: '62.8%',
    normalImgWidth: '100%',
  },
};

// Premium Link jackpot games use the Premium Link badge in any section; SPJ games only inside the Premium Link section.
export const getBadgeSectionName = (
  game: Pick<IGameSettings, 'jackpotName' | 'displayJackpotName'>,
  sectionName: string,
): string => {
  const name = game.displayJackpotName || game.jackpotName || '';
  return name === JACKPOT_NAMES.PREMIUM_LINK ? SECTION_NAMES.PREMIUM_LINK : sectionName;
};

export const getBadgeCSSVars = (sectionName: string): React.CSSProperties => {
  const config = SECTION_BADGE_REGISTRY[sectionName] ?? DEFAULT_BADGE_CONFIG;
  return {
    '--badge-plate-width': config.plateWidth,
    '--badge-spj-left': config.spjLeft,
    '--badge-spj-top': config.spjTop,
    '--badge-spj-width': config.spjWidth,
    '--badge-spj-width-md': config.spjWidthMd,
    '--badge-normal-picture-width': config.normalPictureWidth,
    '--badge-normal-img-width': config.normalImgWidth,
  } as React.CSSProperties;
};
